"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useLocalizedStrings;

var _useWebChatAPIContext2 = _interopRequireDefault(require("./useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useLocalizedStrings() {
  var _useWebChatAPIContext = (0, _useWebChatAPIContext2.default)(),
      localizedStrings = _useWebChatAPIContext.localizedStrings;

  return localizedStrings;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9pbnRlcm5hbC91c2VMb2NhbGl6ZWRTdHJpbmdzLmpzIl0sIm5hbWVzIjpbInVzZUxvY2FsaXplZFN0cmluZ3MiLCJsb2NhbGl6ZWRTdHJpbmdzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSxtQkFBVCxHQUErQjtBQUM1Qyw4QkFBNkIscUNBQTdCO0FBQUEsTUFBUUMsZ0JBQVIseUJBQVFBLGdCQUFSOztBQUVBLFNBQU9BLGdCQUFQO0FBQ0QiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB1c2VXZWJDaGF0QVBJQ29udGV4dCBmcm9tICcuL3VzZVdlYkNoYXRBUElDb250ZXh0JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlTG9jYWxpemVkU3RyaW5ncygpIHtcbiAgY29uc3QgeyBsb2NhbGl6ZWRTdHJpbmdzIH0gPSB1c2VXZWJDaGF0QVBJQ29udGV4dCgpO1xuXG4gIHJldHVybiBsb2NhbGl6ZWRTdHJpbmdzO1xufVxuIl19